module.exports = __WEBPACK_EXTERNAL_MODULE_bn_js__;